import { createApiAction } from '@app/packages/api/utils'
import type { ApiPromousage } from '@app/packages/api/v2/types/entities'

export const getPromoUsages = () =>
  createApiAction('getPromoUsages', dispatch => dispatch<{ data: ApiPromousage[] }>({ method: 'GET', endpoint: '/api/v2/promo_usages' }))

export const postPromoUsages = (code: string) =>
  createApiAction('postPromoUsages', dispatch =>
    dispatch<{ data: ApiPromousage }>({ method: 'POST', endpoint: '/api/v2/promo_usages', body: JSON.stringify({ code }) })
  )
